import React, {PureComponent} from "react"

import history from "@irati/utils/history"
import ValidationButton from "@irati/ui/src/FormItem/ValidationButton"
import intercom from "@irati/utils/intercom"
import {FormattedMessage} from "@irati/utils/lang"
import {H3} from "@irati/ui/src/Headings"
import {Para} from "@irati/ui/src/Labels"
import Hr from "@irati/ui/src/Layout/Hr"
import Flex from "@irati/ui/src/Flex"
import {Firstname, Lastname, Email} from "@irati-web/fields/user"
import usersService from "@irati/identity/services/users"
import Loading from "@irati/ui/src/Loading"
import Button from "@irati/ui/src/Button"
import successImage from "@irati/ui/images/success.svg"
import Routes, {SETUP_TENANT} from "@irati-web/app/src/routeConfig"
import Form from "@irati/ui/src/Form"
import {NewUserInput} from "@irati/types/ops"
import authentication from "@irati/auth"

import {Content, Container} from "../StepContent/styled"
import {MaxWContent, Img, MarginButton} from "./styled"
import Header from "./Header"

interface Props {}
interface State {
  firstname: string,
  lastname: string,
  email: string,
  load: Promise<void> | null,
  success: boolean
}

class InviteAdmin extends PureComponent<Props, State> {
  state: State = {
    firstname: "",
    lastname: "",
    email: "",
    load: null,
    success: false
  }

  // If the user came from a setup step, send them back else send to the first uncompleted step
  handleGoBack = () => {
    const basePath = Routes[SETUP_TENANT]
    const lastVisitedStepPath = this.props?.location?.state?.lastVisitedStepPath
    if (lastVisitedStepPath) {
      history.push(`${basePath}${lastVisitedStepPath}`)
    } else {
      history.push(basePath)
    }
  }

  // Ensure the intercom help bubble is not shown
  componentWillMount = () => intercom.hide()
  componentWillUnmount = () => intercom.show()

  createAdmin = () => {
    const {firstname, lastname, email} = this.state

    const user: NewUserInput = {
      businessId: authentication.userTenant().uuid,
      firstName: firstname,
      lastName: lastname,
      email,
      language: authentication.userLocale()
    }

    const load = usersService.create({user}).then((createdUser) => {
      return usersService.makeUserGlobalAdmin(createdUser.uuid)
    }).then(() => this.setState({success: true}))
    this.setState({load})
  }

  updateInput = (label: string, value: string) => {
    // @ts-ignore
    this.setState({
      [label]: value
    })
  }
  render() {
    const {firstname, lastname, email, load, success} = this.state

    if (success)
      return (
        <Container>
          <Content>
            <Header />
            <Img src={successImage} />
            <H3 tiny>
              <FormattedMessage id="setup_tenant.inviteAdmin.success.title" />
            </H3>
            <Para>
              <FormattedMessage id="setup_tenant.inviteAdmin.success.description" />
            </Para>
            <Button onClick={this.handleGoBack}>
              <FormattedMessage id="setup_tenant.inviteAdmin.button.back" />
            </Button>
          </Content>
        </Container>
      )

    return (
      <Container>
        <Content>
          <Form>
            <Header />
            <MaxWContent maxWidth="400px">
              <Firstname value={firstname} onChange={(value: string) => this.updateInput("firstname", value)} />
              <Lastname value={lastname} onChange={(value: string) => this.updateInput("lastname", value)} />
            </MaxWContent>

            <MaxWContent maxWidth="700px">
              <Email value={email} onChange={(value: string) => this.updateInput("email", value)} />
              <Hr />

              <Para bold>
                <FormattedMessage id="setup_tenant.inviteAdmin.tip.header" />
              </Para>
              <Para>
                <FormattedMessage id="setup_tenant.inviteAdmin.tip.text" />
              </Para>
            </MaxWContent>

            <Flex direction="column">
              <Loading load={load} useLoader={false} />
              <Flex direction="row">
                <ValidationButton primary load={load} onClick={this.createAdmin}>
                  <FormattedMessage id="setup_tenant.inviteAdmin.button.text" />
                </ValidationButton>
                <MarginButton onClick={this.handleGoBack}>
                  <FormattedMessage id="setup_tenant.inviteAdmin.button.back" />
                </MarginButton>
              </Flex>
            </Flex>
          </Form>
        </Content>
      </Container>
    )
  }
}

export default InviteAdmin
